export const EQUALIZER_ICON = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="equalizer-icon"
        viewBox="0 0 14 17.5"
        data-testid="equalizer-icon-svg"
    >
        <circle
            strokeWidth="1px"
            stroke="#CBCBCB"
            fill="#FFFFFF"
            cx="50%"
            cy="50%"
            r="8"
        ></circle>
        <rect x="2" y="6.13" width="1.7" height="5.24" />
        <rect x="4" y="4" width="1.7" height="9.5" />
        <rect x="6.1" y="2" width="1.7" height="13.5" />
        <rect x="8.2" y="1.85" width="1.7" height="13.81" />{" "}
        <rect x="10.2" y="5.18" width="1.7" height="7.14" />
    </svg>
);

export const getAudioPlayBtn = (label) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="play-btn"
        viewBox="0 0 60 60"
        focusable="false"
        role="img"
        aria-label={label}
    >
        <circle
            strokeWidth="2px"
            stroke="#CBCBCB"
            fill="#FFFFFF"
            cx="30"
            cy="30"
            r="28"
        ></circle>
        <polygon fill="#000000" points="43 30 23 20 23 40"></polygon>
    </svg>
);
